<template>
  <div class="purchaserecord pointer">
    <NavBar title="购买记录" />
    <div class="main" v-if="!emptyState">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          offset="200"
        >
          <Purchrecord
            v-for="(item, index) in OrderList"
            :key="index"
            :purows="item"
          />
        </van-list>
      </van-pull-refresh>
    </div>
    <van-empty
      v-else
      class="custom-image"
      :image="require('@/assets/imgs/empty.png')"
      description="暂时没有订单数据哦！"
    />
  </div>
</template>
  
  <script>
import NavBar from "@/components/NavBar.vue";
import Purchrecord from "@/components/buy/purchrecord.vue";
import { orderlist } from "@/api/buy/index";
export default {
  name: "purchaserecord",
  components: {
    NavBar,
    Purchrecord,
  },
  data() {
    return {
      pageNum: 0,
      zongtotal: 0,
      OrderList: [],
      loading: false,
      finished: false,
      refreshing: false,
      emptyState: false,
    };
  },

  mounted() {},

  methods: {
    async onLoad() {
      let that = this;
      that.pageNum++;
      let data = {
        pageNum: that.pageNum,
        pageSize: 10,
      };
      await orderlist(data).then((res) => {
        if (res.code == 200) {
          that.OrderList.push(...res.data.rows);
          that.zongtotal = res.data.total;
          that.refreshing = false;
          that.loading = false;
          if (that.OrderList.length <= 0) {
            this.emptyState = true;
          }
        }
        if (res.data.rows.length <= 0) {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNum = 0;
      this.OrderList = [];
      this.onLoad();
    },
  },
};
</script>
  
  <style lang="less" scoped>
.purchaserecord {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.baseBox {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -1px 8px 0 hsla(0, 0%, 39%, 0.2);
  color: #333;
  margin-left: auto;
  margin-right: auto;
  padding: 8px 0;
  .qdsq_btn {
    width: 90%;
    height: 44px;
    border: none;
    background: #886df3;
    border-radius: 44px;
    font-size: 16px;
    color: #f6f8fb;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: center;
  }
}
</style>